import React from 'react';
import { ResponsiveImage } from '../../../components';
import css from './AuthenticationPageBackground.module.css';
import StarsCanvas from './StarsCanvas';

function AuthenticationPageBackground({ backgroundImage }) {
  const variants = backgroundImage?.attributes?.variants
    ? Object.keys(backgroundImage.attributes.variants)
    : [];

  return (
    <div className={css.canvasContainer}>
      <div className={css.landscape}>
        {backgroundImage ? (
          <ResponsiveImage
            alt="Authentication background"
            image={backgroundImage}
            variants={variants}
          />
        ) : null}
      </div>
      <div className={css.filter}></div>
      <StarsCanvas />
    </div>
  );
}

export default AuthenticationPageBackground